import React, {useContext, useEffect, useState} from "react";
import {isNativeApp, postDataToEventBus, subscribeToLifeCycleEvent} from "../../utils";

export const NativeWebAuthnContext = React.createContext({});

const NativeWebAuthnProvider = (props) => {
  const [nativeWebAuthnData, setNativeWebAuthnData] = useState(null)
  const [isDeviceCompatible, setIsDeviceCompatible] = useState(false)

  const { children } = props;

  useEffect(() => {
    if (isNativeApp()) {
      postDataToEventBus("GET_WEBAUTHN_RECORD");
      subscribeToLifeCycleEvent("SEND_WEBAUTHN_DATA", (payload) => {
        setNativeWebAuthnData({...payload?.localStorageObject});
        setIsDeviceCompatible(payload?.deviceSupport);
      })
    }
  }, []);

  const context = {
    nativeWebAuthnData,
    setNativeWebAuthnData,
    isDeviceCompatible,
  }
  return (
      <NativeWebAuthnContext.Provider value={context}>
        {children}
      </NativeWebAuthnContext.Provider>
  )
}

export const useNativeWebAuthnData = () => {
  const context = useContext(NativeWebAuthnContext);

  if (context === undefined) {
    throw new Error("useNativeWebAuthnData context need to be used within Native WebAuthn Provider");
  }

  return context;
};

export default NativeWebAuthnProvider;
